import { useEffect, useRef } from 'react';
import { cartService } from '../../services/cartService';
import { GlobalErrorHandler } from '../../errors';

type UseCartBootstrapOptions = {
  /**
   * 是否只触发一次；用于避免空车时重复轮询导致的请求风暴。
   */
  once?: boolean;
};

/**
 * 统一的购物车数据引导 Hook
 * - 将 Service 调用留在 Hook 层，避免 UI 直连 Service
 * - 提供 once 开关，防止空购物车场景无限触发 fetch
 */
export function useCartBootstrap(shouldFetch: boolean, options: UseCartBootstrapOptions = {}) {
  const { once = false } = options;
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (!shouldFetch) return;
    if (once && hasFetchedRef.current) return;

    hasFetchedRef.current = true;
    void cartService.fetchCart().then((result) => {
      if (!result.ok) {
        GlobalErrorHandler.handle(result.error, {
          scope: 'bootstrap',
          source: 'fetch',
          userInitiated: false,
          silent: true
        });
      }
    });
  }, [shouldFetch, once]);
}
